<script setup>

import KdContainer from "./kdContainer.vue";
</script>

<template>
  <kd-container>
    <el-form label-width="155px" :model="form" :rules="rules" ref="formRef">
      <el-form-item label="是否存在市场物料" prop="hasInventoryVehicle">
        <el-radio-group :disabled="marketVehicles && marketVehicles.hasInventoryVehicle != undefined" v-model="form.hasInventoryVehicle">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-show="form.hasInventoryVehicle == 1">
        <el-form-item label="市场物料处置方案" prop="inventoryVehicleDisposalSolution">
          <el-input :disabled="marketVehicles && marketVehicles.inventoryVehicleDisposalSolution !== undefined" placeholder="请输入市场物料处置方案" v-model="form.inventoryVehicleDisposalSolution" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <div v-if="marketVehicles && marketVehicles.inventoryVehicleDisposalSolutionFiles != undefined && marketVehicles.inventoryVehicleDisposalSolutionFiles.length > 0">
          <el-form-item label="附件">
            <file-upload-list
              v-if="marketVehicles && marketVehicles.inventoryVehicleDisposalSolutionFiles !== undefined"
              ref="fileUploadList"
              :fileList="form.inventoryVehicleDisposalSolutionFiles"
            ></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="form.inventoryVehicleDisposalSolutionFiles"
              :httpRequest="imAction"/>
          </el-form-item>
        </div>
        <el-form-item label="市场物料处理情况" prop="inventoryVehicleHandStatusMessage">
          <el-input :disabled="marketVehicles &&
                               marketVehicles.inventoryVehicleHandStatusMessage !== null &&
                               marketVehicles.inventoryVehicleHandStatusMessage !== '' && this.taskDefKey !== 'Activity_1qakyfn'"
                    placeholder="请输入市场物料处理情况" v-model="form.inventoryVehicleHandStatusMessage"
                    type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </div>
      <div v-show="taskDefKey == 'Activity_1q5528k' || taskDefKey == 'Activity_1jrizcd' || taskDefKey == 'Activity_1n4y57e'">
        <el-form-item label="索赔结果" prop="handSuggestion">
          <el-input :disabled="marketVehicles && marketVehicles.handSuggestion !== null && marketVehicles.handSuggestion !== ''"
                    placeholder="请输入索赔结果" v-model="form.handSuggestion"
                    type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
      </div>
      <div v-if="auditForm">
        <el-form-item>
          <el-button class="lang-but" type="primary" @click="submitDataBtClick">确定</el-button>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item>
          <el-button class="lang-but" type="primary" @click="auditPassBtClick">通过</el-button>
          <el-button v-show="this.taskDefKey != 'Activity_1qakyfn' && this.taskDefKey!= 'Activity_09gocxv' " class="lang-but" type="danger" @click="auditRejectBtClick">驳回</el-button>
        </el-form-item>
      </div>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss">

</style>
<script>
import {baseURL} from "../../util/url";
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";


/**
 * 18.5-责任单位 上传市场物料处置情况
 */
export default {
  name: "kdAccountUnitUploadInventoryHandStatusAudit",
  components: { KdAuditPassDialog },
    props: {
      taskId:String,
      questionId:String,
      taskDefKey:String,
      marketVehicles: Object,
      auditForm:{
        type: Boolean,
        default: false
      },
      disableForm:{
        type: Boolean,
        default: false
      }
    },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      assignUser:"",
      dialogVisible:false,
      auditPassDialogVisible: false,
      form:{
        inventoryVehicleDisposalSolutionFiles:[],
        marketVehicleDisposalSolutionFiles:[],
        hasInventoryVehicle: 1,
        hasMarketVehicle: "",
        inventoryVehicleDisposalSolution: "",
        marketVehicleDisposalSolution: "",
        inventoryVehicleHandStatusMessage:"",
        inventoryVehicleHandStatusMessageFiles:[],
        rejectReason: "",
        auditText: "",
      },
      rules: {
        hasInventoryVehicle: [
          {
            required: true, message: "是否存在市场物料不能为空", trigger: ["blur", "change"]
          }
        ],
        inventoryVehicleDisposalSolution:[
          {
            required: true, message: "市场物料处置方案不能为空", trigger: ["blur", "change"]
          }
        ],
        rejectReason: [
          {
            required: true, message: "驳回原因不能为空", trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
    "form.hasInventoryVehicle"(newVal) {
      this.form.inventoryVehicleDisposalSolution = this.marketVehicles.inventoryVehicleDisposalSolution??"";
      if (newVal == 0) {
        this.$set(this.rules, "inventoryVehicleDisposalSolution", []);
        this.$refs.formRef.clearValidate("inventoryVehicleDisposalSolution");
      } else {
        this.$set(this.rules, "inventoryVehicleDisposalSolution", [{ required: true, message: "市场物料处置方案不能为空", trigger: ["blur", "change"] }]);
      }
    }
  },
  methods: {
    submitDataBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        if(!this.checkVinData()){
          return
        }
        this.$confirm('确认提交吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let formData = {
            taskId:this.taskId,
            approval: true
          }
          requestSubmitAuditKD(formData).then(res => {
            if(res.status == "0"){
              this.$DonMessage.success('提交成功!');
              this.backRouterPath();
            }
          })
        })
      })
    },
    auditPassBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.auditPassDialogVisible = true;
      })

    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        marketVehicles: this.form,
        variables: {
          approval: true,
        },
      }
      requestSubmitAuditKD(formData).then(res => {
        if (res.status == "0") {
          this.$DonMessage.success('审批通过!');
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      })

    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let formData = {
          nowTaskId:this.taskId,
          questionId:this.questionId,
          taskDefKey:this.taskDefKey,
          auditText: this.form.rejectReason,
          variables:{
            approval: false
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if(res.status == "0"){
            this.$DonMessage.success('驳回成功!');
            this.backRouterPath();
            this.dialogVisible = false;
          }else {
            this.$DonMessage.error(res.message);
          }
        })
      })
    },
  },
  mounted() {
    if(this.marketVehicles){
      this.form.hasMarketVehicle = (this.marketVehicles.hasMarketVehicle)?Number(this.marketVehicles.hasMarketVehicle):0;
      this.form.marketVehicleDisposalSolution = this.marketVehicles.marketVehicleDisposalSolution??"";
      this.form.marketVehicleDisposalSolutionFiles = this.marketVehicles.marketVehicleDisposalSolutionFiles??[];
      this.form.hasInventoryVehicle = (this.marketVehicles.hasInventoryVehicle != undefined)?Number(this.marketVehicles.hasInventoryVehicle):0;
      this.form.inventoryVehicleDisposalSolution = this.marketVehicles.inventoryVehicleDisposalSolution??"";
      this.form.inventoryVehicleHandStatusMessage = this.marketVehicles.inventoryVehicleHandStatusMessage??"";
      this.form.inventoryVehicleDisposalSolutionFiles = this.marketVehicles.inventoryVehicleDisposalSolutionFiles??[];
    }
  }
}
</script>
